import { z } from 'zod';

import { VISIBILITY_SCOPE } from '../constants';

/**
 * Zod schema for the POST /suppliers/{de_id}/responsible_persons request
 * payload (SupplierResponsiblePersonCreate).
 */
export const zodAddSupplierResponsiblePersonPayloadSchema = z.object({
  userId: z.uuid(),
  visibilityScope: z.enum(VISIBILITY_SCOPE).default('company_account'),
});
